class TrapFocus extends HTMLElement {
  constructor () {
    super()

    this.idx = null
    this.handleKeydown = this.handleKeydown.bind(this)
    this.handleOpenFocusParent = this.handleOpenFocusParent.bind(this)

    this.setupEventListeners()
  }

  setupEventListeners () {
    this.parentEl.addEventListener('keydown', this.handleOpenFocusParent)
  }

  handleOpenFocusParent (event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()

      this.dropdownEl.open = true

      const firstChildEl = this.childEls[0]
      if (firstChildEl) {
        firstChildEl.focus()
      }

      this.trapFocus()
    }
  }

  trapFocus () {
    this.addEventListener('keydown', this.handleKeydown)
  }

  removeFocus (event) {
    event.preventDefault()

    this.dropdownEl.open = false
    this.parentEl.focus()
    this.removeEventListener('keydown', this.handleKeydown)
    this.idx = null
  }

  handleKeydown (event) {
    if (event.key === 'Enter' || event.key === ' ') {
      if (this.idx !== null && document.activeElement.matches('[data-trap-focus-el="child"]')) {
        event.preventDefault()

        document.activeElement.click()
        this.removeFocus(event)
      }
    }

    if (event.key === 'Tab') {
      event.preventDefault()

      this.idx = Array.from(this.childEls).indexOf(document.activeElement)
      let nextIdx

      if (event.shiftKey) {
        nextIdx = (this.idx - 1 + this.childEls.length) % this.childEls.length
      } else {
        nextIdx = (this.idx + 1) % this.childEls.length
      }
      this.childEls[nextIdx].focus()
    }

    if (event.key === 'Escape') {
      this.removeFocus(event)
    }
  }

  get parentEl () {
    return this.querySelector('[data-trap-focus-el="parent"]')
  }

  get childEls () {
    return this.querySelectorAll('[data-trap-focus-el="child"]')
  }

  get dropdownEl () {
    return this.querySelector('[data-trap-focus-el="dropdown"]')
  }
}

customElements.define('trap-focus', TrapFocus)
